import {dynamicUrl} from './src/constants';
import Map from './src/Map';

dynamicUrl.dynamicUrl = 'https://geomapfish-demo-2-9.camptocamp.com/dynamic.json?interface=api';

const lib = {
  Map,
};

export default lib;
